import 'sanitize.css';

import '../resources/base';

import '../resources/components/header/header.scss';
import '../resources/components/faq/faq.js';
import '../resources/components/footer/footer.scss';
import '../resources/components/logo-trail/logo-trail.js';
import '../resources/components/logo-trail/logo-trail.scss';
import '../resources/components/paragraphs/paragraphs.scss';
import '../resources/components/partner/grid.scss';
import '../resources/components/performance/full.scss';
import '../resources/components/performance/grid.js';
import '../resources/components/performance/grid.scss';
import '../resources/components/performance/teaser.scss';
import '../resources/components/random-background/random-background.js';
import '../resources/components/task-bar/task-bar.scss';
import '../resources/components/text/text.scss';

import '../resources/elements/_heading.scss';
import '../resources/pages/homepage.scss';
